<template>
  <v-container fluid>
    <div class="d-flex mb-2">
      <h2 style="font-weight: 400">ข้อมูลบริษัท</h2>
    </div>
    <v-card outlined class="pa-4">
      <v-form ref="form" lazy-validation @submit.prevent="onSubmit">
        <label class="body-2">
          รหัสบริษัท
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="1"
          v-model="company.company_code"
          :rules="[
            (v) => !!v || 'โปรดระบุรหัสบริษัท',
            (v) =>
              (v && v.length >= 1 && v.length <= 128) ||
              'รหัสบริษัทต้องอยู่ระหว่าง 1 ถึง 128 ตัวอักษร',
            (v) =>
              /^[ก-๏A-Za-z0-9_.-\s]+$/.test(v) ||
              'ใส่ได้เฉพาะ ก-ฮ, A-Z, a-z, 0-9, จุด, ขีด, underscore',
            (v) =>
              (!!v && v[0] !== '.' && v[0] !== '-' && v[0] !== '_') ||
              'ไม่สามารถขึ้นต้นด้วย จุด, ขีด, underscore',
          ]"
          required
          clearable
          @change="checkEmpty($event, 'company_code')"
          outlined
          dense
        >
        </v-text-field>
        <label class="body-2">
          ชื่อบริษัท
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="2"
          v-model="company.title_th"
          :rules="[(v) => !!v || 'โปรดระบุชื่อบริษัท']"
          required
          clearable
          @change="checkEmpty($event, 'title_th')"
          outlined
          dense
        ></v-text-field>
        <label class="body-2">
          ชื่อบริษัท (อังกฤษ)
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="3"
          v-model="company.title_en"
          :rules="[(v) => !!v || 'โปรดระบุชื่อบริษัท (อังกฤษ)']"
          clearable
          @change="checkEmpty($event, 'title_en')"
          outlined
          dense
        ></v-text-field>
        <label class="body-2"> ที่อยู่ </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="4"
          v-model="company.address_th"
          required
          clearable
          @change="checkEmpty($event, 'address_th')"
          outlined
          dense
        ></v-text-field>
        <label class="body-2"> ที่อยู่ (อังกฤษ) </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="5"
          v-model="company.address_en"
          clearable
          @change="checkEmpty($event, 'address_en')"
          outlined
          dense
        ></v-text-field>
        <label class="body-2"> เว็บไซต์ </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="6"
          v-model="company.www"
          :rules="[
            (v) =>
              !v ||
              /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(
                v
              ) ||
              'ระบุเว็บไซต์ไม่ถูกต้อง',
          ]"
          clearable
          @change="checkEmpty($event, 'www')"
          outlined
          dense
        ></v-text-field>
        <div class="mb-6">
          <label class="body-2"> รหัสอ้างอิงพนักงาน </label>
          <v-switch
            style="margin-top: -1px"
            v-model="company.is_employee_reference_code"
            :label="
              company.is_employee_reference_code
                ? 'เปิดการใช้งาน'
                : 'ปิดการใช้งาน'
            "
            hide-details
          ></v-switch>
        </div>
        <div class="mb-6">
          <label class="body-2"> บัตรพนักงานมากกว่า 1 ใบ </label>
          <v-switch
            style="margin-top: -1px"
            v-model="company.is_employee_multiple_card"
            :label="
              company.is_employee_multiple_card
                ? 'เปิดการใช้งาน'
                : 'ปิดการใช้งาน'
            "
            hide-details
          ></v-switch>
        </div>
        <div>
          <label class="body-2"> รูปภาพ </label>
          <v-file-input
            :rules="[
              (value) =>
                !value ||
                value.size < 2000000 ||
                'Logo size should be less than 2 MB!',
            ]"
            class="fix-google-chrome mt-1"
            v-model="fileImage"
            ref="imgFileInput"
            accept="image/jpeg"
            show-size
            @change="onFileChange"
            @click:clear="onFileClear"
            outlined
            dense
          >
          </v-file-input>
        </div>
        <v-img
          v-if="uploadFilePreview"
          style="width: 480px"
          :src="'data:image/jpeg;base64,' + uploadFilePreview"
          width="100%"
        ></v-img>
        <v-img
          v-else-if="company.url_logo"
          style="width: 480px"
          :src="company.url_logo"
          width="100%"
        ></v-img>
        <div v-if="company.url_logo">
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::company:logo:delete')"
            @click="handleDeleteCompanyLogo"
            color="error"
            text
          >
            ลบ
          </v-btn>
        </div>
        <div class="mt-2">
          <p class="ma-0 body-2">jpeg เท่านั้น</p>
          <p class="ma-0 body-2">ขนาดไฟล์ไม่เกิน 2Mb</p>
        </div>
      </v-form>
    </v-card>
    <div class="mt-4 mb-8">
      <v-btn
        tabindex="7"
        color="primary"
        :disabled="
          !isCompanyDataChange ||
          (uiCtrl && !uiCtrl.isEnable('btn:::company:update'))
        "
        @click="onSave"
        >บันทึก
      </v-btn>
      <v-btn tabindex="8" class="ml-2" @click="onCancel">ยกเลิก</v-btn>
    </div>
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  name: 'Company',
  components: {
    ConfirmDialog,
  },
  data() {
    return {
      dialogForbidden: false,
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      fileImage: null,
      uploadFilePreview: null,
      loading: false,
      company: {
        company_code: '',
        title_th: '',
        title_en: '',
        address_th: '',
        address_en: '',
        www: '',
      },
      companyInit: {
        company_code: '',
        title_th: '',
        title_en: '',
        address_th: '',
        address_en: '',
        www: '',
      },
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    isCompanyDataChange() {
      if (
        this.company.company_code !== this.companyInit.company_code ||
        this.company.title_th !== this.companyInit.title_th ||
        this.company.title_en !== this.companyInit.title_en ||
        this.company.address_th !== this.companyInit.address_th ||
        this.company.address_en !== this.companyInit.address_en ||
        this.company.www !== this.companyInit.www ||
        this.company.is_employee_reference_code !==
          this.companyInit.is_employee_reference_code ||
        this.company.is_employee_multiple_card !==
          this.companyInit.is_employee_multiple_card
      ) {
        return true
      }
      return false
    },
  },
  created() {
    if (this.uiCtrl && !this.uiCtrl.isEnable('menu:::company')) {
      this.$router.push({ name: 'Home' })
    }

    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'บริษัท',
        disabled: true,
      },
    ])

    this.loadData()
  },
  methods: {
    ...mapActions({
      editCompany: 'company/editCompany',
      fetchCompany: 'company/fetchCompany',
      deleteCompanyLogo: 'company/deleteCompanyLogo',
    }),
    onCancel() {
      this.company = JSON.parse(JSON.stringify(this.companyInit))
    },
    handleDeleteCompanyLogo() {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบ Logo',
        value: '',
        item: '',
      }
    },
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    submitConfirmDialogDelete() {
      this.confirmDialogDeleteLoading = true

      const { company_uuid } = this.$store.state.authentication.company

      this.deleteCompanyLogo(company_uuid)
        .then(() => {
          this.confirmDialogDeleteLoading = false
          this.confirmDialogDelete = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'ลบข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.company.url_logo = null

          // this.$emit('formActionCompleted', this.formAction)
          // this.$refs.form.reset()
        })
        .catch((error) => {
          this.confirmDialogDeleteLoading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    async onFileChange(file) {
      if (file) {
        this.fileImage = file
        const result = await this.getBase64(file)
        this.uploadFilePreview = result.split(',').pop()
      }
    },
    onFileClear() {
      this.fileImage = null
      this.uploadFilePreview = null
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
      })
    },
    async onSave() {
      if (this.$refs.form.validate()) {
        try {
          const { company_uuid } = this.$store.state.authentication.company

          let file_base64 = null
          let file_ext = null

          if (this.fileImage) {
            const result = await this.getBase64(this.fileImage)
            file_base64 = result.split(',').pop()
            file_ext = this.fileImage.type.split('/').pop()
          }

          const payload = {
            company_uuid,
            company: {
              ...this.company,
              logo: file_base64 ? file_base64 : null,
              logo_extension: file_ext ? file_ext : null,
            },
          }

          this.$store.state.loading = true

          await this.editCompany(payload)

          this.companyInit = JSON.parse(JSON.stringify(this.company))

          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'แก้ไขข้อมูลสำเร็จ',
          }

          this.$store.commit('SET_SNACKBAR', snackbar)
        } catch (error) {
          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        }
      }
    },
    checkEmpty(value, field) {
      if (value) {
        this.company[field] = value.trim()
      }
    },
    loadData() {
      const { company_uuid } = this.$store.state.authentication.company

      this.$store.state.loading = true

      this.fetchCompany(company_uuid)
        .then((location) => {
          this.$store.state.loading = false

          const company = this.$store.state.company.company

          this.company = JSON.parse(JSON.stringify(company))
          this.companyInit = JSON.parse(JSON.stringify(company))
        })
        .catch((error) => {
          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
  },
}
</script>
